import type { FeatureNames } from "./feature-names";

/** Dutch names of every staff feature and settings category (same keys as features.fr.ts). */
export const featuresNl: FeatureNames = {
  features: {
    SEARCH_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Accounts zoeken",
    VIEW_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Een account bekijken",
    REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Een nummer tonen",
    EDIT_CUSTOMER_SETTINGS_STAFF_FEATURE_ENABLEMENT: "Instellingen van een klant wijzigen",
    CLAIM_CASES_STAFF_FEATURE_ENABLEMENT: "Dossiers oppakken",
    REASSIGN_CASES_STAFF_FEATURE_ENABLEMENT: "Dossiers opnieuw toewijzen",
    ACT_ON_BEHALF_STAFF_FEATURE_ENABLEMENT: "Namens een klant handelen",
    CORRECT_ACCOUNT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Accountgegevens corrigeren",
    REVIEW_VERIFICATIONS_STAFF_FEATURE_ENABLEMENT: "Verificaties beoordelen",
    VIEW_ID_IMAGES_STAFF_FEATURE_ENABLEMENT: "Identiteitsbeelden bekijken",
    APPROVE_PROS_STAFF_FEATURE_ENABLEMENT: "Pro's goedkeuren",
    VIEW_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Betalingen bekijken",
    ISSUE_REFUNDS_STAFF_FEATURE_ENABLEMENT: "Terugbetalen",
    ISSUE_CREDITS_STAFF_FEATURE_ENABLEMENT: "Tegoed toekennen",
    WAIVE_FEES_STAFF_FEATURE_ENABLEMENT: "Kosten kwijtschelden",
    MARK_PAYMENTS_PAID_STAFF_FEATURE_ENABLEMENT: "Een betaling als betaald markeren",
    MANAGE_PLAN_PRICES_STAFF_FEATURE_ENABLEMENT: "Abonnementsprijzen instellen",
    RUN_PROMOS_STAFF_FEATURE_ENABLEMENT: "Acties voeren",
    OFFER_DISCOUNTS_STAFF_FEATURE_ENABLEMENT: "Kortingen geven",
    MANAGE_SUBSCRIPTIONS_STAFF_FEATURE_ENABLEMENT: "Abonnement verlengen of beëindigen",
    APPROVE_PAYMENT_REQUESTS_STAFF_FEATURE_ENABLEMENT: "Boven de limiet goedkeuren",
    RECONCILE_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Betalingen afstemmen",
    EXPORT_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Exporteren",
    HANDLE_REPORTS_STAFF_FEATURE_ENABLEMENT: "Meldingen behandelen",
    SET_REPORT_SEVERITY_STAFF_FEATURE_ENABLEMENT: "Ernst van een melding bepalen",
    SUSPEND_PENDING_INVESTIGATION_STAFF_FEATURE_ENABLEMENT: "Voorlopige schorsing",
    ISSUE_VERDICTS_STAFF_FEATURE_ENABLEMENT: "Een oordeel uitspreken",
    BAN_PERMANENTLY_STAFF_FEATURE_ENABLEMENT: "Permanent verbannen",
    HANDLE_APPEALS_STAFF_FEATURE_ENABLEMENT: "Bezwaren behandelen",
    REFER_TO_POLICE_STAFF_FEATURE_ENABLEMENT: "Doorverwijzen naar de politie",
    SHARE_DATA_WITH_POLICE_STAFF_FEATURE_ENABLEMENT: "Gegevens delen met de politie",
    PLACE_LEGAL_HOLDS_STAFF_FEATURE_ENABLEMENT: "Bewijs bevriezen",
    MODERATE_REVIEWS_STAFF_FEATURE_ENABLEMENT: "Beoordelingen modereren",
    SEND_SMS_STAFF_FEATURE_ENABLEMENT: "Een sms sturen",
    SEND_BULK_SMS_STAFF_FEATURE_ENABLEMENT: "Bulk-sms sturen",
    EDIT_SMS_TEMPLATES_STAFF_FEATURE_ENABLEMENT: "Sms-sjablonen wijzigen",
    MANAGE_APP_FEATURES_STAFF_FEATURE_ENABLEMENT: "App-functies beheren",
    EDIT_RULES_STAFF_FEATURE_ENABLEMENT: "Regels wijzigen",
    EDIT_PRICING_STAFF_FEATURE_ENABLEMENT: "Tarieven wijzigen",
    EDIT_CATEGORIES_STAFF_FEATURE_ENABLEMENT: "Vakgebieden wijzigen",
    INVITE_STAFF_STAFF_FEATURE_ENABLEMENT: "Uitnodigen in het team",
    DEACTIVATE_STAFF_STAFF_FEATURE_ENABLEMENT: "Een teamlid deactiveren",
    END_STAFF_SESSIONS_STAFF_FEATURE_ENABLEMENT: "Sessies beëindigen",
    MANAGE_TEAMS_STAFF_FEATURE_ENABLEMENT: "Teams beheren",
    MANAGE_ROLES_STAFF_FEATURE_ENABLEMENT: "Rollen beheren",
    MANAGE_ACTION_ENABLEMENTS_STAFF_FEATURE_ENABLEMENT: "Actie-inschakelingen beheren",
    ASSIGN_ROLES_STAFF_FEATURE_ENABLEMENT: "Rollen toewijzen",
    MANAGE_LEADS_STAFF_FEATURE_ENABLEMENT: "Verkoop en groei",
    VIEW_MARKETPLACE_STAFF_FEATURE_ENABLEMENT: "Marktbeheer",
    MANAGE_HUMAN_RESOURCES_STAFF_FEATURE_ENABLEMENT: "Personeelszaken",
    VIEW_AUDIT_LOG_STAFF_FEATURE_ENABLEMENT: "Het auditlogboek lezen",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_FEATURE_ENABLEMENT: "Gevoelige waarden bekijken",
    VIEW_HEALTH_DASHBOARD_STAFF_FEATURE_ENABLEMENT: "Het dashboard bekijken",
  },
  /** The permissions that sit on those features (ADR-0019), by settingId. */
  permissions: {
    ISSUE_REFUND_STAFF_PERMISSION: "Een terugbetaling uitgeven",
    SETTLE_REFUND_STAFF_PERMISSION: "Een terugbetaling afhandelen",
    ISSUE_CREDIT_STAFF_PERMISSION: "Een tegoed uitgeven",
    WAIVE_FEE_STAFF_PERMISSION: "Kosten kwijtschelden",
    REPLY_TO_CUSTOMER_STAFF_PERMISSION: "Een klant beantwoorden",
    CLOSE_CASE_STAFF_PERMISSION: "Een dossier sluiten",
  },
  /** Customer features (Fonctionnalités), by settingId. */
  customerFeatures: {
    SEARCH_PROS_USER_FEATURE_ENABLEMENT: "Pro's zoeken",
    NEARBY_PROS_USER_FEATURE_ENABLEMENT: "Pro's in de buurt",
    REQUEST_PRO_USER_FEATURE_ENABLEMENT: "Een pro aanvragen",
    POST_OPEN_JOB_USER_FEATURE_ENABLEMENT: "Open aanvraag plaatsen",
    JOB_PHOTOS_USER_FEATURE_ENABLEMENT: "Foto's in een aanvraag",
    SELECT_QUOTE_USER_FEATURE_ENABLEMENT: "Een offerte kiezen",
    LEAVE_REVIEWS_USER_FEATURE_ENABLEMENT: "Een beoordeling geven",
    REQUEST_CALLBACK_USER_FEATURE_ENABLEMENT: "Terugbelverzoek",
    SAVE_FAVORITE_PROS_USER_FEATURE_ENABLEMENT: "Favoriete pro's",
    REBOOK_PRO_USER_FEATURE_ENABLEMENT: "Opnieuw een pro boeken",
    SHARE_PRO_PROFILE_USER_FEATURE_ENABLEMENT: "Profiel van een pro delen",
    SCHEDULE_JOB_USER_FEATURE_ENABLEMENT: "Een aanvraag inplannen",
    URGENT_JOB_USER_FEATURE_ENABLEMENT: "Dringende aanvraag",
    BECOME_PRO_USER_FEATURE_ENABLEMENT: "Pro worden",
    LEAD_PREFERENCES_USER_FEATURE_ENABLEMENT: "Voorkeuren voor kansen",
    EDIT_RATES_USER_FEATURE_ENABLEMENT: "Tarieven wijzigen",
    BROWSE_OPEN_JOBS_USER_FEATURE_ENABLEMENT: "Open aanvragen bekijken",
    QUOTE_JOBS_USER_FEATURE_ENABLEMENT: "Offertes op aanvragen",
    PRO_SUBSCRIPTIONS_USER_FEATURE_ENABLEMENT: "Pro-abonnementen",
    SUBMIT_VERIFICATION_USER_FEATURE_ENABLEMENT: "Verificatie indienen",
    PAUSE_LEADS_USER_FEATURE_ENABLEMENT: "Kansen pauzeren",
    PORTFOLIO_PHOTOS_USER_FEATURE_ENABLEMENT: "Foto's van werk",
    QUICK_REPLIES_USER_FEATURE_ENABLEMENT: "Snelle antwoorden",
    ACTIVITY_PAGE_USER_FEATURE_ENABLEMENT: "Activiteitenpagina",
    DECLARE_JOB_OUTCOME_USER_FEATURE_ENABLEMENT: "Uitkomst van een aanvraag melden",
    LEAD_NOTIFICATIONS_USER_FEATURE_ENABLEMENT: "Kansen als melding",
    SMS_LEADS_USER_FEATURE_ENABLEMENT: "Kansen per sms",
    JOB_REMINDERS_USER_FEATURE_ENABLEMENT: "Herinneringen voor aanvragen",
    SWITCH_MODE_USER_FEATURE_ENABLEMENT: "Wisselen tussen klant en pro",
    MESSAGING_USER_FEATURE_ENABLEMENT: "Berichten sturen",
    SEND_PHOTOS_USER_FEATURE_ENABLEMENT: "Foto's sturen",
    SHARE_LOCATION_USER_FEATURE_ENABLEMENT: "Locatie delen",
    CHANGE_PHONE_USER_FEATURE_ENABLEMENT: "Telefoonnummer wijzigen",
    CHANGE_EMAIL_USER_FEATURE_ENABLEMENT: "E-mail wijzigen",
    CONTACT_US_USER_FEATURE_ENABLEMENT: "Contact opnemen",
    CREATE_CLIENT_PROFILE_USER_FEATURE_ENABLEMENT: "Klantprofiel aanmaken",
    REPORT_USER_USER_FEATURE_ENABLEMENT: "Iemand melden",
    BLOCK_USER_USER_FEATURE_ENABLEMENT: "Iemand blokkeren",
    APPEAL_DECISION_USER_FEATURE_ENABLEMENT: "Bezwaar maken tegen een besluit",
    SECURITY_ACTIVITY_USER_FEATURE_ENABLEMENT: "Beveiligingsactiviteit",
    REFER_FRIENDS_USER_FEATURE_ENABLEMENT: "Vrienden uitnodigen",
  },
  /** Every action, so the audit log names what was done instead of its id (#185). */
  actions: {
    SIGN_UP_USER_ACTION: "Registreren",
    SIGN_IN_USER_ACTION: "Aanmelden",
    SIGN_OUT_USER_ACTION: "Afmelden",
    UPDATE_PERSONAL_INFO_USER_ACTION: "Persoonlijke gegevens bijwerken",
    CHANGE_PHONE_USER_ACTION: "Telefoonnummer wijzigen",
    CHANGE_EMAIL_USER_ACTION: "E-mailadres wijzigen",
    CHANGE_PASSWORD_USER_ACTION: "Wachtwoord wijzigen",
    SWITCH_MODE_USER_ACTION: "Wisselen tussen klant en pro",
    CREATE_CLIENT_PROFILE_USER_ACTION: "Een klantprofiel aanmaken",
    UPDATE_SETTING_USER_ACTION: "Een instelling wijzigen",
    VIEW_SECURITY_ACTIVITY_USER_ACTION: "Beveiligingsactiviteit bekijken",
    REFER_FRIEND_USER_ACTION: "Een vriend uitnodigen",
    DELETE_ACCOUNT_USER_ACTION: "Het account verwijderen",
    BECOME_PRO_USER_ACTION: "Pro worden",
    SUBMIT_VERIFICATION_USER_ACTION: "Een identiteitsbewijs ter verificatie indienen",
    UPDATE_PRO_PROFILE_USER_ACTION: "Het pro-profiel bijwerken",
    UPDATE_RATES_USER_ACTION: "Tarieven bijwerken",
    ADD_PORTFOLIO_PHOTO_USER_ACTION: "Een foto van werk toevoegen",
    REMOVE_PORTFOLIO_PHOTO_USER_ACTION: "Een foto van werk verwijderen",
    UPDATE_LEAD_PREFERENCES_USER_ACTION: "Voorkeuren voor kansen bijwerken",
    PAUSE_LEADS_USER_ACTION: "Kansen pauzeren",
    RESUME_LEADS_USER_ACTION: "Kansen hervatten",
    VIEW_OPEN_JOBS_USER_ACTION: "Open aanvragen bekijken",
    VIEW_ACTIVITY_USER_ACTION: "Activiteit bekijken",
    REQUEST_PRO_USER_ACTION: "Een pro aanvragen",
    POST_OPEN_JOB_USER_ACTION: "Een open aanvraag plaatsen",
    REBOOK_PRO_USER_ACTION: "Opnieuw een pro boeken",
    UPDATE_JOB_USER_ACTION: "Een aanvraag bijwerken",
    ADD_JOB_PHOTOS_USER_ACTION: "Foto's aan een aanvraag toevoegen",
    SCHEDULE_JOB_USER_ACTION: "Een aanvraag inplannen",
    MARK_JOB_URGENT_USER_ACTION: "Een aanvraag als dringend markeren",
    SELECT_QUOTE_USER_ACTION: "Een offerte kiezen",
    CANCEL_JOB_USER_ACTION: "Een aanvraag annuleren",
    SUBMIT_QUOTE_USER_ACTION: "Een offerte versturen",
    UPDATE_QUOTE_USER_ACTION: "Een offerte bijwerken",
    WITHDRAW_QUOTE_USER_ACTION: "Een offerte intrekken",
    ACCEPT_JOB_USER_ACTION: "Een aanvraag aannemen",
    DECLINE_JOB_USER_ACTION: "Een aanvraag weigeren",
    DECLARE_JOB_OUTCOME_USER_ACTION: "Melden hoe een aanvraag is afgelopen",
    SEARCH_PROS_USER_ACTION: "Pro's zoeken",
    SEARCH_PROS_NEARBY_USER_ACTION: "Pro's in de buurt zoeken",
    VIEW_PRO_PROFILE_USER_ACTION: "Het profiel van een pro bekijken",
    SAVE_FAVORITE_PRO_USER_ACTION: "Een pro als favoriet opslaan",
    REMOVE_FAVORITE_PRO_USER_ACTION: "Een pro uit de favorieten verwijderen",
    SHARE_PRO_PROFILE_USER_ACTION: "Het profiel van een pro delen",
    OPEN_CONVERSATION_USER_ACTION: "Een gesprek openen",
    SEND_MESSAGE_USER_ACTION: "Een bericht sturen",
    SEND_PHOTO_USER_ACTION: "Een foto sturen",
    SHARE_LOCATION_USER_ACTION: "Een locatie delen",
    READ_MESSAGES_USER_ACTION: "Berichten lezen",
    SAVE_QUICK_REPLY_USER_ACTION: "Een snel antwoord opslaan",
    LEAVE_REVIEW_USER_ACTION: "Een beoordeling geven",
    SUBSCRIBE_TO_PLAN_USER_ACTION: "Een abonnement nemen",
    CANCEL_SUBSCRIPTION_USER_ACTION: "De verlenging opzeggen",
    RESUME_SUBSCRIPTION_USER_ACTION: "De verlenging hervatten",
    CHANGE_PLAN_USER_ACTION: "Van abonnement wisselen",
    PAY_FEE_USER_ACTION: "Kosten betalen",
    CONTACT_SUPPORT_USER_ACTION: "Contact opnemen met support",
    REQUEST_CALLBACK_USER_ACTION: "Een terugbelverzoek doen",
    REPORT_USER_USER_ACTION: "Iemand melden",
    BLOCK_USER_USER_ACTION: "Iemand blokkeren",
    UNBLOCK_USER_USER_ACTION: "Iemand deblokkeren",
    APPEAL_DECISION_USER_ACTION: "Bezwaar maken tegen een besluit",
    CREATE_EXPERIMENT_STAFF_ACTION: "Een experiment starten",
    MOVE_EXPERIMENT_STAFF_ACTION: "Een experiment uitbreiden of stoppen",
    ADD_LEAD_STAFF_ACTION: "Een prospect toevoegen",
    MOVE_LEAD_STAFF_ACTION: "Een prospect verder brengen",
    CREATE_CAMPAIGN_STAFF_ACTION: "Een campagne opstellen",
    SEND_CAMPAIGN_STAFF_ACTION: "Een campagne versturen",
    OPEN_INCIDENT_STAFF_ACTION: "Een storing openen",
    UPDATE_INCIDENT_STAFF_ACTION: "Een storing bijwerken",
    VIEW_MARKETPLACE_STAFF_ACTION: "Zien hoe de markt draait",
    VIEW_MARKETPLACE_JOB_STAFF_ACTION: "Een klus bekijken",
    SIGN_IN_STAFF_ACTION: "Aanmelden bij de console",
    SIGN_OUT_STAFF_ACTION: "Afmelden bij de console",
    SET_PASSWORD_STAFF_ACTION: "Een consolewachtwoord instellen",
    UPDATE_STAFF_SETTING_STAFF_ACTION: "Een console-instelling wijzigen",
    SEARCH_ACCOUNTS_STAFF_ACTION: "Accounts zoeken",
    VIEW_ACCOUNT_STAFF_ACTION: "Een account bekijken",
    REVEAL_CONTACT_DETAILS_STAFF_ACTION: "Een telefoonnummer tonen",
    EDIT_CUSTOMER_SETTING_STAFF_ACTION: "Een instelling van een klant wijzigen",
    CORRECT_ACCOUNT_DETAILS_STAFF_ACTION: "Accountgegevens corrigeren",
    CLAIM_CASE_STAFF_ACTION: "Een dossier oppakken",
    LOG_CALL_STAFF_ACTION: "Een telefoongesprek vastleggen",
    REPLY_TO_CASE_STAFF_ACTION: "Een klant beantwoorden",
    ADD_CASE_NOTE_STAFF_ACTION: "Een interne notitie toevoegen",
    CLOSE_CASE_STAFF_ACTION: "Een dossier sluiten",
    REASSIGN_CASE_STAFF_ACTION: "Een dossier opnieuw toewijzen",
    LINK_CASE_CUSTOMER_STAFF_ACTION: "Een klant aan een dossier koppelen",
    START_ON_BEHALF_SESSION_STAFF_ACTION: "Beginnen namens een klant te handelen",
    END_ON_BEHALF_SESSION_STAFF_ACTION: "Stoppen met handelen namens een klant",
    VIEW_VERIFICATION_STAFF_ACTION: "Een verificatie bekijken",
    APPROVE_VERIFICATION_STAFF_ACTION: "Een verificatie goedkeuren",
    REJECT_VERIFICATION_STAFF_ACTION: "Een verificatie afwijzen",
    VIEW_ID_IMAGES_STAFF_ACTION: "Identiteitsbeelden bekijken",
    APPROVE_PRO_STAFF_ACTION: "Een pro goedkeuren",
    REJECT_PRO_STAFF_ACTION: "Een pro afwijzen",
    VIEW_PAYMENTS_STAFF_ACTION: "Betalingen bekijken",
    ISSUE_REFUND_STAFF_ACTION: "Een terugbetaling uitgeven",
    ISSUE_CREDIT_STAFF_ACTION: "Een tegoed uitgeven",
    WAIVE_FEE_STAFF_ACTION: "Kosten kwijtschelden",
    MARK_PAYMENT_PAID_STAFF_ACTION: "Kosten als betaald markeren",
    APPROVE_PAYMENT_REQUEST_STAFF_ACTION: "Een verzoek goedkeuren",
    REJECT_PAYMENT_REQUEST_STAFF_ACTION: "Een verzoek weigeren",
    SETTLE_REFUND_STAFF_ACTION: "Een terugbetaling afhandelen",
    SET_PLAN_PRICE_STAFF_ACTION: "De prijs van een abonnement instellen",
    CREATE_PROMO_STAFF_ACTION: "Een actie aanmaken",
    END_PROMO_STAFF_ACTION: "Een actie beëindigen",
    CREATE_DISCOUNT_STAFF_ACTION: "Een korting aanmaken",
    END_DISCOUNT_STAFF_ACTION: "Een korting beëindigen",
    EXTEND_SUBSCRIPTION_STAFF_ACTION: "Een abonnement verlengen",
    END_SUBSCRIPTION_STAFF_ACTION: "Een abonnement beëindigen",
    RECONCILE_PAYMENTS_STAFF_ACTION: "Betalingen afstemmen",
    EXPORT_PAYMENTS_STAFF_ACTION: "Betalingen exporteren",
    OPEN_SAFETY_REPORT_STAFF_ACTION: "Een melding openen",
    ADD_REPORT_EVIDENCE_STAFF_ACTION: "Bewijs aan een melding toevoegen",
    SET_REPORT_SEVERITY_STAFF_ACTION: "De ernst van een melding bepalen",
    SUSPEND_PENDING_INVESTIGATION_STAFF_ACTION: "Een account schorsen tijdens het onderzoek",
    LIFT_SUSPENSION_STAFF_ACTION: "Een schorsing opheffen",
    ISSUE_VERDICT_STAFF_ACTION: "Een uitspraak doen",
    BAN_PERMANENTLY_STAFF_ACTION: "Een account definitief uitsluiten",
    DECIDE_APPEAL_STAFF_ACTION: "Over een bezwaar beslissen",
    REFER_TO_POLICE_STAFF_ACTION: "Een dossier doorgeven aan de politie",
    SHARE_DATA_WITH_POLICE_STAFF_ACTION: "Gegevens delen met de politie",
    PLACE_LEGAL_HOLD_STAFF_ACTION: "Een juridische blokkade plaatsen",
    RELEASE_LEGAL_HOLD_STAFF_ACTION: "Een juridische blokkade opheffen",
    HIDE_REVIEW_STAFF_ACTION: "Een beoordeling verbergen",
    RESTORE_REVIEW_STAFF_ACTION: "Een beoordeling herstellen",
    SEND_SMS_STAFF_ACTION: "Een sms sturen",
    SEND_BULK_SMS_STAFF_ACTION: "Een sms naar veel mensen sturen",
    EDIT_SMS_TEMPLATE_STAFF_ACTION: "Een sms-sjabloon wijzigen",
    SET_USER_FEATURE_ENABLEMENT_STAFF_ACTION: "Een klantfunctie aan- of uitzetten",
    CREATE_RULE_VERSION_STAFF_ACTION: "Een bedrijfsregel wijzigen",
    EDIT_PRICING_STAFF_ACTION: "De kostenstaffels wijzigen",
    EDIT_CATEGORIES_STAFF_ACTION: "De vakgebieden wijzigen",
    INVITE_STAFF_STAFF_ACTION: "Een teamlid uitnodigen",
    DEACTIVATE_STAFF_STAFF_ACTION: "Een teamlid deactiveren",
    REACTIVATE_STAFF_STAFF_ACTION: "Een teamlid heractiveren",
    END_STAFF_SESSION_STAFF_ACTION: "De sessies van een teamlid beëindigen",
    REQUEST_PERMISSION_STAFF_ACTION: "Een permissie aanvragen",
    DECIDE_PERMISSION_REQUEST_STAFF_ACTION: "Op een permissieverzoek antwoorden",
    UPDATE_ACTION_ENABLEMENT_STAFF_ACTION: "Actie-inschakeling wijzigen",
    REQUEST_TIME_OFF_STAFF_ACTION: "Verlof aanvragen",
    DECIDE_TIME_OFF_STAFF_ACTION: "Over een verlofaanvraag beslissen",
    SET_EMPLOYMENT_STAFF_ACTION: "Een dienstverband bewerken",
    OPEN_JOB_STAFF_ACTION: "Een vacature openen",
    EDIT_JOB_STAFF_ACTION: "Een vacature bewerken",
    MOVE_CANDIDATE_STAFF_ACTION: "Een kandidaat verder brengen",
    OPEN_PAYROLL_STAFF_ACTION: "Een loonmaand openen",
    EDIT_PAYROLL_LINE_STAFF_ACTION: "Een loonregel blokkeren of vrijgeven",
    CLOSE_PAYROLL_STAFF_ACTION: "Een loonmaand afsluiten",
    OPEN_REVIEW_CYCLE_STAFF_ACTION: "Een beoordelingsronde openen",
    WRITE_REVIEW_STAFF_ACTION: "Een beoordeling schrijven",
    EDIT_COURSE_STAFF_ACTION: "Een cursus toevoegen of wijzigen",
    ENROL_IN_COURSE_STAFF_ACTION: "Zich inschrijven voor een cursus",
    CREATE_TEAM_STAFF_ACTION: "Een team aanmaken",
    EDIT_TEAM_STAFF_ACTION: "Een team bewerken",
    SET_TEAM_MEMBERSHIP_STAFF_ACTION: "Instellen wie in het team zit",
    CREATE_ROLE_STAFF_ACTION: "Een rol aanmaken",
    EDIT_ROLE_STAFF_ACTION: "Een rol wijzigen",
    SET_STAFF_PERMISSION_STAFF_ACTION: "Een machtiging geven of intrekken",
    SET_STAFF_FEATURE_ENABLEMENT_STAFF_ACTION: "Een functie geven of intrekken",
    ASSIGN_ROLE_STAFF_ACTION: "Een rol toewijzen",
    REMOVE_ROLE_STAFF_ACTION: "Een rol verwijderen",
    VIEW_AUDIT_LOG_STAFF_ACTION: "Het auditlogboek lezen",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_ACTION: "Gevoelige auditwaarden bekijken",
    VIEW_HEALTH_DASHBOARD_STAFF_ACTION: "Het gezondheidsdashboard bekijken",
    EXPIRE_JOB_SYSTEM_ACTION: "Een onbeantwoorde aanvraag laten verlopen",
    EXPIRE_QUOTE_SYSTEM_ACTION: "Een offerte laten verlopen",
    CLOSE_OTHER_QUOTES_SYSTEM_ACTION: "De andere offertes sluiten",
    OPEN_CONVERSATION_ON_QUOTE_SYSTEM_ACTION: "Een gesprek openen over een offerte",
    NOTIFY_USER_SYSTEM_ACTION: "Een notificatie sturen",
    NOTIFY_NEW_LEAD_SYSTEM_ACTION: "Een pro op de hoogte brengen van een nieuwe kans",
    SEND_LEAD_SMS_SYSTEM_ACTION: "Een kans per sms sturen",
    NOTIFY_JOB_REMINDER_SYSTEM_ACTION: "Een herinnering voor een aanvraag sturen",
    CONFIRM_FEE_PAYMENT_SYSTEM_ACTION: "Een kostenbetaling bevestigen",
    FAIL_FEE_PAYMENT_SYSTEM_ACTION: "Een mislukte kostenbetaling vastleggen",
    ACTIVATE_SUBSCRIPTION_SYSTEM_ACTION: "Een abonnement activeren",
    SUSPEND_SUBSCRIPTION_SYSTEM_ACTION: "Een abonnement opschorten",
    RENEW_SUBSCRIPTION_SYSTEM_ACTION: "Een abonnement verlengen",
    EXPIRE_SUBSCRIPTION_SYSTEM_ACTION: "Een verlopen abonnement beëindigen",
    REMIND_SUBSCRIPTION_EXPIRY_SYSTEM_ACTION: "Een pro eraan herinneren dat zijn abonnement afloopt",
    EXPIRE_SETTING_VALUE_SYSTEM_ACTION: "Een instellingswaarde laten verlopen",
    DELETE_ID_IMAGES_SYSTEM_ACTION: "Identiteitsbeelden verwijderen",
    FLAG_BANNED_DOCUMENT_SYSTEM_ACTION: "Een verboden document markeren",
    SUSPEND_ON_CRITICAL_REPORT_SYSTEM_ACTION: "Schorsen bij een kritieke melding",
  },
  /** The settings someone chooses for themselves, read as words, not ids (#185). */
  settings: {
    THEME_USER_SETTING: "Thema",
    COLOR_VIBE_USER_SETTING: "Kleur",
    LANGUAGE_USER_SETTING: "Taal",
    LOW_DATA_MODE_USER_SETTING: "Databespaarmodus",
    NEW_LEAD_NOTIFICATION_USER_SETTING: "Breng me op de hoogte van nieuwe kansen",
    QUOTE_RECEIVED_NOTIFICATION_USER_SETTING: "Breng me op de hoogte als er een offerte binnenkomt",
    NEW_LEAD_SMS_USER_SETTING: "Nieuwe kansen per sms sturen",
    QUOTE_RECEIVED_SMS_USER_SETTING: "Een offerte per sms sturen",
    LEAD_TRADES_USER_SETTING: "Vakgebieden waarvoor ik kansen wil",
    LEAD_SERVICE_AREA_USER_SETTING: "Waar ik werk",
    LEAD_RADIUS_USER_SETTING: "Hoe ver ik reis",
    LEAD_DAYS_USER_SETTING: "Dagen waarop ik werk aanneem",
    URGENT_JOBS_USER_SETTING: "Dringende aanvragen",
    CONSOLE_THEME_STAFF_SETTING: "Consolethema",
    CONSOLE_LANGUAGE_STAFF_SETTING: "Consoletaal",
  },
  /** The grid's section titles. */
  categories: {
    appearance: "Weergave",
    notifications: "Notificaties",
    leads: "Kansen",
    discovery: "Zoeken",
    jobs: "Aanvragen",
    profile: "Profiel",
    accounts: "Accounts",
    support: "Dossiers",
    onBehalf: "Namens een klant",
    onboarding: "Verificatie",
    payments: "Betalingen",
    safety: "Vertrouwen & veiligheid",
    messaging: "Berichten",
    configuration: "Configuratie",
    staff: "Team & toegang",
    audit: "Audit",
  },
};
